// src/lib/black-friday-script-template.ts
import bfScript from "./scripts/bf-script-v2.js?raw"; // Note the ?raw suffix

export const getBlackFridayScript = (sheetUrl: string) => {
  // Sanitize the URL to prevent script injection
  const sanitizedUrl = sheetUrl.replace(/["\\]/g, "\\$&");
  const sheetUrlLine = `const SHEET_URL = '${sanitizedUrl}'; // enter YOUR url between the single quotes\n\n`;
  return sheetUrlLine + bfScript;
};

export const handleCopyBFScript = async (sheetUrl: string): Promise<boolean> => {
  try {
    const fullScript = getBlackFridayScript(sheetUrl);
    await navigator.clipboard.writeText(fullScript);
    return true;
  } catch (error) {
    console.error("Failed to copy BF script:", error);
    return false;
  }
};
